import script from "./ModalTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ModalTemplate.vue?vue&type=style&index=0&id=3110c8e2&lang=scss"

const __exports__ = script;

export default __exports__